<template>
<div>
    <!-- modal -->
    <b-modal id="lawLedesFormModal" centered size="xl" no-close-on-backdrop ref="lawLedesFormModal" :title=" $t('lawLedes.info')" @close="clear()" hide-footer>
        <!-- <agent-note-form ref="agentNoteForm"></agent-note-form> -->
        <!-- <client-form ref="clientForm"></client-form> -->
        <div class="custom-search d-flex justify-content-end">
            <b-row>
                <b-col>
                    <b-button variant="outline-primary" size="sm" class="mr-1" @click.prevent="addOrUpdate">
                        {{$t('others.ok_title')}}
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <validation-observer ref="simpleRules">
            <b-form>
                <b-row>
                    <b-col class="col-md-4">
                        <validation-provider :name="$t('lawLedes.country')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <label for="lawLedes-country-input">{{ $t('lawLedes.country') }}</label>
                            <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="countrySelect" value-field="id" text-field="name" :options="countryOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                    <b-col class="col-md-4">
                        <label for="lawLedes-zip-code-input">{{ $t('lawLedes.zip_code') }}</label>
                        <b-form-group>
                            <b-form-input id="lawLedes-zip-code-input" v-model="zipCode" size="sm" maxlength="50" />
                        </b-form-group>
                    </b-col>
                    <b-col class="col-md-4">
                        <label for="lawLedes-tax-input">{{ $t('lawLedes.tax') }}</label>
                        <b-form-group>
                            <b-form-input id="lawLedes-tax-input" v-model="tax" size="sm" maxlength="50" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-4">
                        <validation-provider :name="$t('lawLedes.lawLedes_type')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <label for="lawLedes-type-input">{{ $t('lawLedes.lawLedes_type') }}</label>
                            <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="lawLedesTypeSelect" value-field="id" text-field="name" :options="lawLedesTypeOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                    <b-col class="col-md-4">
                        <validation-provider :name="$t('lawLedes.employee')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <label for="lawLedes-type-input">{{ $t('lawLedes.employee') }}</label>
                            <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="employeeSelect" value-field="id" text-field="name" :options="employeeOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                    <b-col class="col-md-4">
                        <label for="lawLedes-query-input">{{ $t('lawLedes.query') }}</label>
                        <b-form-group>
                            <b-form-input id="lawLedes-query-input" v-model="query" size="sm" maxlength="50" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-3">
                        <label for="ledes-shortName-input">{{ $t('lawLedes.short_name') }}</label>
                        <b-form-group>
                            <b-form-input id="ledes-shortName-input" v-model="shortName" size="sm" maxlength="50" />
                        </b-form-group>
                    </b-col>

                    <b-col class="col-md-3">
                        <label for="ledes-priorityt-imekeeper-input">{{ $t('lawLedes.priority_timekeeper') }}</label>
                        <b-form-group>
                            <b-form-input id="ledes-priority-timekeeper-input" v-model="priorityTimekeeper" size="sm" maxlength="50" />
                        </b-form-group>
                    </b-col>

                    <b-col class="col-md-3">
                        <label for="ledes-priority-timekeeper-name-input">{{ $t('lawLedes.priority_timekeeper_name') }}</label>
                        <b-form-group>
                            <b-form-input id="ledes-priority-timekeeper-name-input" v-model="priorityTimekeeperName" size="sm" maxlength="50" />
                        </b-form-group>
                    </b-col>

                    <b-col class="col-md-3">
                        <label for="ledes-priority-cassification-input">{{ $t('lawLedes.priority_cassification') }}</label>
                        <b-form-group>
                            <b-form-input id="ledes-priority-cassification-input" v-model="priorityCassification" size="sm" maxlength="50" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12 mt-1">
                        <b-form-group>
                            <label for="lawLedes-agent-input"> {{ $t('lawLedes.agent') }} </label>
                            <b-input-group class="d-flex align-items-center">
                                <validation-provider :name=" $t('lawLedes.agent')" #default="{ errors }" :rules="{ excluded: 0 }">
                                    <b-form-group label-for="lawLedes-agent-input" :state="errors.length > 0 ? false:null" style="width: 1200px">
                                        <v-select id="lawLedes-agent-input" v-model="lawLedesAgentSelect" :options="lawLedesAgentOption" @input="setClientId" class="w-100 custom-v-select agentInput" :get-option-label="$formatAgent" @search="onSearch"></v-select>
                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>
                                <b-input-group-append>
                                    <b-dropdown style="width: 3em; height: 2.5em" id="dropdown-grouped" variant="outline-primary" right class="dropdown-icon-wrapper" size="sm">
                                        <template #button-content>
                                            <feather-icon icon="MenuIcon" size="10" class="align-middle" />
                                        </template>
                                        <b-dropdown-item @click="getClientInfo(0)">
                                            <span>{{this.$t('others.add_client')}}</span>
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="getClientInfo(lawLedesAgentSelect.clientId)">
                                            <span>{{this.$t('others.show_agent')}}</span>
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="getCopyContentInfo(lawLedesAgentSelect)">
                                            <span>{{this.$t('others.copy_content')}}</span>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
        <b-card :hidden="hiddenControl">
            <b-row>
                <b-col>
                    <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                        <b-tab active :title=" $t('lawLedes.detail')" style="width:100%;">
                            <lawLedes-detail-list :getLawLedesList="getLawLedesList" :lawLedesId="this.id"></lawLedes-detail-list>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-card>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLawLedesList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            lawLedesTypeSelect: 0,
            lawLedesTypeOption: [],
            countryOption: [],
            lawLedesAgentOption: [],
            lawLedesAgentSelect: 0,
            countrySelect: 0,
            hiddenControl: true,
            tax: '',
            query: '',
            zipCode: '',
            clientId: 0,
            employeeSelect: 0,
            employeeOption: [],
            priorityTimekeeper: '',
            priorityTimekeeperName: '',
            priorityCassification: '',
            shortName:'',
        }
    },
    methods: {
        async getClientInfo(clientId) {
            this.$refs.clientFormModal.showInfo(clientId)
        },
        async getAgentNoteInfo(clientAccountingId) {
            this.$refs.agentNoteForm.getNoteListByAccountingId(clientAccountingId)
        },
        setClientId(event) {
            if (event != null) {
                this.clientId = event.clientId
            } else {
                this.clientId = null;
            }
        },
        onSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            if (search.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    clientName: search,
                    forAgentOrInvoice: 1,
                }
                const controller = {
                    name: 'ClientAccounting',
                    actionName: 'GetLawClientAccountingByLawClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.lawLedesAgentOption = response.data.clientList
                    loading(false)
                })
            }
        },
        clear() {
            this.query = '';
            this.lawLedesTypeSelect = 0;
            this.countrySelect = 0;
            this.lawLedesAgentSelect = 0;
            this.tax = '';
            this.priorityTimekeeper = ''
            this.priorityTimekeeperName = ''
            this.priorityCassification = ''
            this.hiddenControl = true;
            this.employeeSelect = 0;
            this.shortName = ''
        },
        getCopyContentInfo(val) {
            const nameOnly = val.clientName.split(' | ')[0]
            navigator.clipboard.writeText(nameOnly).then(() => {
                this.$SuccessAlert(`${this.$t('others.copied')}:\n${nameOnly}`)
            }).catch(err => {
                this.$WarningAlert(this.$t('others.copy_failed'))
                console.error('Copy failed: ', err)
            })
        },
        showInfo(id) {
            this.$refs['lawLedesFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawLedes'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.employeeOption = response.data.employeeList
                    this.countryOption = response.data.countryList
                    this.lawLedesTypeOption = response.data.lawLedesTypeList
                    this.countryOption.splice(0, 0, this.$nullSelected('name'))
                    this.lawLedesTypeOption.splice(0, 0, this.$nullSelected('name'))
                    this.employeeOption.splice(0, 0, this.$nullSelected('name'))
                    this.query = response.data.lawLedes.query
                    this.tax = response.data.lawLedes.tax
                    this.name = response.data.lawLedes.name
                    this.priorityTimekeeper = response.data.lawLedes.priorityTimekeeper
                    this.priorityTimekeeperName = response.data.lawLedes.priorityTimekeeperName
                    this.priorityCassification = response.data.lawLedes.priorityCassification  
                    this.zipCode = response.data.lawLedes.zipCode
                    this.shortName = response.data.lawLedes.shortName
                    if (response.data.lawLedes.id > 0) {
                        this.hiddenControl = false
                    } else {
                        this.hiddenControl = true
                    }
                    if (response.data.lawLedes.lawLedesTypeId > 0) {
                        this.lawLedesTypeSelect = response.data.lawLedes.lawLedesTypeId;
                    }
                    if (response.data.lawLedes.countryId > 0) {
                        this.countrySelect = response.data.lawLedes.countryId;
                    }
                    if (response.data.lawLedes.employeeId > 0) {
                        this.employeeSelect = response.data.lawLedes.employeeId;
                    } else {
                        this.employeeSelect = localStorage.getItem('EmployeeId');
                    }
                    if (response.data.lawLedes.clientAccountingId > 0) {
                        const clientAccountingData = {
                            clientAccountingId: response.data.lawLedes.clientAccountingId
                        }
                        const clientAccountingController = {
                            name: 'ClientAccounting',
                            actionName: 'GetClientAccountingByClientName'
                        }
                        const clientAccountingPayload = {
                            data: clientAccountingData,
                            controller: clientAccountingController
                        }
                        this.$store.dispatch('moduleAuth/customService', clientAccountingPayload).then((clientAccountingResponse) => {
                            this.lawLedesAgentOption = clientAccountingResponse.data.clientList
                            this.lawLedesAgentSelect = clientAccountingResponse.data.clientList[0]
                            this.clientId = clientAccountingResponse.data.clientList[0].clientId
                        })
                    } else {
                        this.lawLedesAgentOption = []
                        this.lawLedesAgentSelect = 0;
                    }
                } else {
                    this.$bvModal.hide('lawLedesFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                name: this.name,
                countryId: this.countrySelect,
                lawLedesTypeId: this.lawLedesTypeSelect,
                clientAccountingId: this.lawLedesAgentSelect.clientAccountingId,
                zipCode: this.zipCode,
                employeeId: localStorage.getItem('EmployeeId'),
                tax: this.tax,
                query: this.query,
                priorityTimekeeper: this.priorityTimekeeper,
                priorityTimekeeperName: this.priorityTimekeeperName,
                priorityCassification: this.priorityCassification,
                shortName: this.shortName,
                employeeId: this.employeeSelect                
            }
            const controller = {
                name: 'LawLedes'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.hiddenControl = false
                            this.id = response.data.lawLedesId
                            this.getLawLedesList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.countrySelect = 0,
                                this.lawLedesTypeSelect = 0,
                                this.lawLedesAgentSelect = 0,
                                this.employeeSelect = 0
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

[dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}

.agentInput {
    max-width: 87em !important;
    width: 86em !important;
}

.custom-v-select .vs__selected,
.custom-v-select .vs__dropdown-option {
    white-space: pre-wrap !important;
}
</style>
